import { render, staticRenderFns } from "./DetailsStructure.vue?vue&type=template&id=5b98a8ae&"
import script from "./DetailsStructure.vue?vue&type=script&lang=ts&"
export * from "./DetailsStructure.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsStructure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports